import { useQuery } from "react-query";
import { Auth } from "shared/@auth/Auth";

export function useFeedItem(id) {
  const { makeAuthedRequest } = Auth.useContainer();

  const { data, isLoading, isFetching, isError, error, refetch } = useQuery(
    ["feedItem", id], // <-- Key must be unique, use id
    () =>
      makeAuthedRequest(`feed/item/${id}`, {
        method: "GET",
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          const err = new Error(body?.error?.message || body.message);
          err.status = res.status;
          throw err;
        }
      }),
    {
      enabled: !!id, // <-- Don't run until we actually have an ID
      refetchOnMount: "always",
      // Missing/invalid items won't recover on retry, so fail fast
      retry: (failureCount, err) =>
        err?.status !== 404 && err?.status !== 406 && failureCount < 2,
    }
  );

  return {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  };
}
